import React, {Component} from 'react';
import RouteContextProvider from "./context/RouteContext";
import RouteView from "./RouteView";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import RouteFilterContextProvider from "./context/RouteFilterContext";

class RouteComponent extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <RouteContextProvider>
                    <RouteFilterContextProvider>
                        <RouteView/>
                    </RouteFilterContextProvider>
                </RouteContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default RouteComponent;


// WEBPACK FOOTER //
// ./src/components/routeView/RouteComponent.js